import Avatar from '@orn/shared-web/components/Avatar';
import { cx } from '@orn/shared-web/utils/cx';
import { getInitial } from '@orn/shared-web/utils/getInitials';
import * as React from 'react';

import Entity from '../entity';

interface IMerchant {
  id: string;
  name: string;
  logoUrl?: string | null;
}

interface IMerchantNameAndAvatarProps {
  merchant?: IMerchant | null;
  /** Primary line when there's no `displayNameOverride` and no merchant; also seeds the no-merchant avatar initials. */
  fallbackDescription?: string;
  secondaryText?: React.ReactNode;
  displayNameClassName?: string;
  /** When set, replaces the merchant name as the primary line; the avatar still derives from `merchant`. */
  displayNameOverride?: string;
}

const MerchantNameAndAvatar = ({
  merchant,
  fallbackDescription,
  secondaryText,
  displayNameClassName,
  displayNameOverride,
}: IMerchantNameAndAvatarProps) => {
  const displayName = displayNameOverride ?? merchant?.name ?? fallbackDescription ?? '';

  const defaultAvatar = <Avatar contrastBorder={true} size="sm" shape="circle" initials={getInitial(displayName)} />;

  return (
    <div className="flex min-w-0 items-center gap-2">
      {merchant ? <Entity.Avatar entity={merchant} size="sm" /> : defaultAvatar}
      <div className="flex min-w-0 flex-1 flex-col">
        <span className={cx('text-primary truncate text-base font-medium', displayNameClassName)}>{displayName}</span>
        {secondaryText && <span className="text-tertiary text-sm font-medium">{secondaryText}</span>}
      </div>
    </div>
  );
};

export default MerchantNameAndAvatar;
